'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  height: ', ';\n  width: ', ';\n'], ['\n  height: ', ';\n  width: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  animation: rotate 1s infinite linear;\n  border: ', ';\n  border-right-color: transparent;\n  border-radius: 50%;\n\n  @keyframes rotate {\n    0% {\n      transform: rotate(360deg);\n    }\n    100% {\n      transform: rotate(0deg);\n    }\n  }\n'], ['\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  animation: rotate 1s infinite linear;\n  border: ', ';\n  border-right-color: transparent;\n  border-radius: 50%;\n\n  @keyframes rotate {\n    0% {\n      transform: rotate(360deg);\n    }\n    100% {\n      transform: rotate(0deg);\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject, function (_ref) {
  var size = _ref.size;
  return '' + (0, _polished.rem)(size);
}, function (_ref2) {
  var size = _ref2.size;
  return '' + (0, _polished.rem)(size);
});

var Inner = _styledComponents2.default.div(_templateObject2, function (_ref3) {
  var theme = _ref3.theme,
      size = _ref3.size,
      color = _ref3.color;
  return (0, _polished.rem)(size / 6.5) + ' solid ' + (color !== null ? color : theme.color.primary);
});

var Loader = function Loader(props) {
  var size = props.size,
      className = props.className,
      color = props.color;

  var sizeMapping = {
    m: 16,
    l: 24,
    xl: 40,
    xxl: 110
  };
  var sizeName = size in sizeMapping ? sizeMapping[size] : 16;
  return _react2.default.createElement(
    Wrapper,
    { className: className, size: sizeName },
    _react2.default.createElement(Inner, { size: sizeName, color: color })
  );
};

Loader.propTypes = {
  color: _propTypes2.default.string,
  className: _propTypes2.default.string,
  size: _propTypes2.default.string
};

Loader.defaultProps = {
  color: null,
  className: null,
  size: 'm'
};

exports.default = Loader;
Loader.__docgenInfo = [{
  'description': '',
  'displayName': 'Loader',
  'methods': [],
  'props': {
    'color': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'className': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'size': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'m\'',
        'computed': false
      }
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/Loader/index.js'] = {
    name: 'Loader',
    docgenInfo: Loader.__docgenInfo,
    path: 'src/Loader/index.js'
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/Loader/index.js
// module id = 17
// module chunks = 1